<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="流水号：">
					<el-input v-model="formInline.code" placeholder="请输入流水号" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客：">
					<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in customerInfoList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="金额上限：">
					<el-input v-model="formInline.lessMoney" placeholder="请输入充值金额上限" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="金额下限：">
					<el-input v-model="formInline.moreMoney" placeholder="请输入充值金额下限" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="状态：">
					<el-select v-model="formInline.state" placeholder="请选择状态" clearable size="small">
						<el-option v-for="item in stateList" :key="item.keyId" :label="item.value" :value="parseInt(item.keyId)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/vip/manage', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
			</el-form>
			<div class="table-minheight">
				<STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
					<template #code>
						<el-table-column align="center" label="流水号" min-width="200">
							<template #default="scope">
								<el-link type="primary" @click="handleShowDetail(scope.row)">
									{{ scope.row.code }}
								</el-link>
							</template>
						</el-table-column>
					</template>
					<el-table-column slot="customerInfo.gender" align="center" label="性别" min-width="120">
						<template #default="scope">
							<span v-if="scope.row.customerInfo.gender == 1" class="one_1">
								{{ formatterFre(scope.row.customerInfo.gender) }}
							</span>
							<span v-if="scope.row.customerInfo.gender == 0" class="one_2">
								{{ formatterFre(scope.row.customerInfo.gender) }}
							</span>
						</template>
					</el-table-column>
					<template #isConfirm>
						<el-table-column align="center" label="是否确认" min-width="120">
							<template #default="scope">
								<span v-if="scope.row.isConfirm == true" class="one_1">已确认</span>
								<span v-if="scope.row.isConfirm == false" class="one_2">未确认</span>
							</template>
						</el-table-column>
					</template>
					<template #isFinished>
						<el-table-column align="center" label="是否完成" min-width="120">
							<template #default="scope">
								<span v-if="scope.row.isFinished == true" class="one_1">已完成</span>
								<span v-if="scope.row.isFinished == false" class="one_2">未完成</span>
							</template>
						</el-table-column>
					</template>
					<template #isPhoneBonus>
						<el-table-column align="center" label="电话提成" min-width="120">
							<template #default="scope">
								<span v-if="scope.row.isPhoneBonus == true" class="one_1">有</span>
								<span v-if="scope.row.isPhoneBonus == false" class="one_2">否</span>
							</template>
						</el-table-column>
					</template>
					<template #rechargeMoney>
						<el-table-column align="center" label="充值金额" min-width="130">
							<template #default="scope">￥{{ scope.row.rechargeMoney }}元</template>
						</el-table-column>
					</template>
					<template #bonusMoney>
						<el-table-column align="center" label="赠送金额" min-width="130">
							<template #default="scope">
								<span v-if="!isBonusMoneyValid(scope.row.rechargeMoney, scope.row.bonusMoney)" class="danger" v-money="scope.row.bonusMoney">￥{{ scope.row.bonusMoney }}元</span>
								<span v-else v-money="scope.row.bonusMoney">￥{{ scope.row.bonusMoney }}元</span>
							</template>
						</el-table-column>
					</template>
					<template #operation>
						<el-table-column align="center" label="操作" min-width="220" fixed="right">
							<template #default="scope">
								<el-button v-if="btnPermission.confirm && scope.row.isConfirm == false" size="mini" type="primary" class="el-icon-finished" @click="handleConfirm(scope.row)">确认充值</el-button>
								<el-button
									v-if="btnPermission.payArrears && scope.row.isFinished == false && scope.row.amountMoney > 0"
									size="mini"
									type="primary"
									class="el-icon-finished"
									@click="handlePayArrears(scope.row)"
								>
									补欠款
								</el-button>
								<el-button v-if="btnPermission.returnMoney && scope.row.isFinished == true && scope.row.state != 3" size="mini" type="danger" class="el-icon-view" @click="handleReturnCard(scope.row)">
									退单
								</el-button>
							</template>
						</el-table-column>
					</template>
				</STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>
		</topTab>
		<!-- 补欠款 -->
		<el-dialog :visible.sync="dialogVisible" title="充值补款" width="1050px" append-to-body :close-on-click-modal="false" custom-class="recharge-arrears-dialog">
			<div class="arrears-dialog-content">
				<el-form label-width="100px" size="small" class="arrears-form">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="充值单号">
								<span>{{ currentArrearsOrder ? currentArrearsOrder.code : "" }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="充值金额">
								<span style="color: #f56c6c; font-weight: 600" v-money="currentArrearsOrder ? currentArrearsOrder.rechargeMoney : 0">￥{{ currentArrearsOrder ? currentArrearsOrder.rechargeMoney : 0 }}元</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="已付金额">
								<span style="color: #67c23a; font-weight: 600" v-money="currentArrearsOrder ? currentArrearsOrder.totalPayMoney : 0">￥{{ currentArrearsOrder ? currentArrearsOrder.totalPayMoney : 0 }}元</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="欠款金额">
								<span style="color: #e6a23c; font-weight: 600" v-money="currentArrearsOrder ? (currentArrearsOrder.rechargeMoney - currentArrearsOrder.totalPayMoney) : 0">￥{{ currentArrearsOrder ? (currentArrearsOrder.rechargeMoney - currentArrearsOrder.totalPayMoney).toFixed(2) : 0 }}元</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="支付方式" required>
						<div class="pay-types-row">
							<div v-for="payTypeItem in payTypes" :key="payTypeItem.payTypeId" class="pay-type-item" :class="{ 'pay-type-item-active': payTypeItem.payMoney > 0 }">
								<span class="pay-type-label">{{ payTypeItem.payTypeName }}</span>
								<el-input-number v-model.number="payTypeItem.payMoney" placeholder="0.00" :min="0" :step="0.01" :precision="2" size="small" controls-position="right"></el-input-number>
								<el-input v-model="payTypeItem.payComment" placeholder="备注" clearable size="small"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="支付记录">
						<el-table :cell-class-name="$moneyCellClass" :data="payHistoryList" size="small" border stripe>
							<el-table-column type="index" label="序号" align="center" min-width="60"></el-table-column>
							<el-table-column prop="payTypeStr" label="支付方式" align="center" min-width="80"></el-table-column>
							<el-table-column label="支付金额" align="center" min-width="100">
								<template #default="scope">￥{{ scope.row.payMoney }}元</template>
							</el-table-column>
							<el-table-column prop="creator" label="收款人" align="center" min-width="80"></el-table-column>
							<el-table-column label="支付时间" align="center" min-width="150">
								<template #default="scope">
									{{ scope.row.createTime ? formatDate(scope.row.createTime) : "" }}
								</template>
							</el-table-column>
							<el-table-column prop="payComment" label="备注" align="center" width="auto"></el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<span>
					<el-button size="small" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" size="small" :loading="isSubmitting" @click="handleSubmitPayArrears">确认补款</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 充值记录详情弹窗 -->
		<detailDialog ref="detailDialog"></detailDialog>
		<!-- 充值记录确认弹窗 -->
		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import { GetVipRechargeHistoryPageList, PayVipRechargeMoney, ReturnVIPRecharge } from "@/api/vipApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode as GetPayTypeList, GetEnumConfigDropListByCode } from "@/api/enumApi.js";
import { GetPayHistoryList } from "@/api/payApi.js";
import detailDialog from "@/views/vip/recharge/detailDialog.vue";
import confirm from "@/views/vip/recharge/confirmRecharge.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "会员充值记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				code: "",
				storeKeyId: "",
				customerKeyId: "",
				vipNo: "",
				customerPhone: "",
				lessMoney: "",
				moreMoney: "",
				state: ""
			},
			storeList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "120",
					align: "center",
				},
				{
					prop: "customerInfo.name",
					label: "会员名称",
					minWidth: "100",
					align: "center",
				},
				{
					slot: "customerInfo.gender",
					label: "性别",
					align: "center",
					width: "80",
				},
				{
					prop: "vipNo",
					label: "会员卡编号",
					width: "160",
					align: "center",
				},
				{
					slot: "rechargeMoney",
					label: "充值金额",
					align: "center",
					width: "100"
				},
				{
					slot: "bonusMoney",
					label: "赠送金额",
					align: "center",
					width: "100"
				},
				{
					slot: "code",
					label: "流水号",
					width: "180",
					align: "center"
				},
				{
					prop: "customerInfo.phone",
					label: "会员电话",
					minWidth: "140",
					align: "center"
				},
				{
					prop: "amountMoney",
					label: "欠款金额",
					align: "center",
					width: "100",
					isMoney: true,
					moneyType: "expense"
				},
				{
					prop: "totalPayMoney",
					label: "总支付金额",
					align: "center",
					width: "100",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "isPhoneBonus",
					label: "电话提成",
					align: "center",
					width: "100"
				},
				{
					prop: "stateStr",
					label: "充值状态",
					align: "center",
					width: "100",
					fixed: "right"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					align: "center",
					width: "100"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "170",
					align: "center"
				},
				{
					slot: "isFinished",
					label: "是否完成",
					align: "center",
					width: "100"
				},
				{
					prop: "finishedTime",
					label: "完成时间",
					width: "170",
					align: "center"
				},
				{
					prop: "creator",
					label: "经办人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "经办时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					align: "center"
				}
			],
			customerInfoList: [],
			btnPermission: {
				confirm: false,
				payArrears: false,
				returnMoney: false
			},
			payTypeList: [],
			stateList: [],
			payTypes: [],
			payHistoryList: [],
			currentArrearsOrder: null,
			dialogVisible: false,
			isSubmitting: false
		};
	},
	// 注册组件
	components: {
		detailDialog,
		confirm
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();

		// 按钮权限
		this.getBtnPermission();
	},
	computed: {
		arrearsPayTypeList() {
			var allowedTypes = [1, 2, 3, 4, 6];
			return this.payTypeList.filter((item) => allowedTypes.includes(item.payTypeId));
		}
	},
	methods: {
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.confirm = this.$checkBtnPermission("/vip/rechargeHistory", "confirm");
			this.btnPermission.payArrears = this.$checkBtnPermission("/vip/rechargeHistory", "payArrears");
			this.btnPermission.returnMoney = this.$checkBtnPermission("/vip/rechargeHistory", "returnMoney");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission() {
			const paramer = {};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = [];
						if (res.code == 1) {
							this.userList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null,
				state: this.formInline.state || null
			};
			GetVipRechargeHistoryPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		// 日期格式化
		formatDate(date) {
			if (!date) return "";
			var d = new Date(date);
			var year = d.getFullYear();
			var month = String(d.getMonth() + 1).padStart(2, "0");
			var day = String(d.getDate()).padStart(2, "0");
			var hours = String(d.getHours()).padStart(2, "0");
			var minutes = String(d.getMinutes()).padStart(2, "0");
			var seconds = String(d.getSeconds()).padStart(2, "0");
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
		// 获取客户信息列表
		GetCustomerListByStore(val) {
			const paramer = {
				keyId: val
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.customerInfoList = [];
						if (res.code == 1) {
							this.customerInfoList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 确认充值
		handleConfirm(row) {
			this.$refs.confirm.getConfirmDialog(row);
		},
		// 充值记录补款
		handlePayArrears(row) {
			this.payTypes = [];
			this.arrearsPayTypeList.forEach((item) => {
				this.payTypes.push({
					payTypeId: item.payTypeId,
					payTypeName: item.payTypeName,
					payMoney: 0,
					payComment: ""
				});
			});
			this.currentArrearsOrder = row;
			this.dialogVisible = true;
			this.getPayHistoryList(row.keyId);
		},
		// 获取支付记录列表
		getPayHistoryList(businessKeyId) {
			GetPayHistoryList({
				KeyId: businessKeyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.payHistoryList = res.data || [];
						this.payHistoryList.forEach((item) => {
							var payType = this.payTypeList.find((p) => p.payTypeId == item.payType);
							if (payType) {
								item.payTypeStr = payType.payTypeName;
							}
						});
					} else {
						this.payHistoryList = [];
					}
				})
				.catch((err) => {
					this.payHistoryList = [];
				});
		},
		// 充值记录补款弹窗
		handleSubmitPayArrears() {
			var totalPayMoney = 0;
			for (var i = 0; i < this.payTypes.length; i++) {
				var payTypeItem = this.payTypes[i];
				if (payTypeItem.payMoney <= 0) continue;
				var payMoney = parseFloat(payTypeItem.payMoney);
				if (isNaN(payMoney)) {
					this.$message.error("请输入有效的数字金额");
					return;
				}
				if (payMoney <= 0) {
					this.$message.error("请输入有效的支付金额（必须大于0）");
					return;
				}
				payTypeItem.payMoney = parseFloat(payMoney.toFixed(2));
				totalPayMoney += payTypeItem.payMoney;
			}
			if (totalPayMoney <= 0) {
				this.$message.error("请输入有效的支付金额（必须大于0）");
				return;
			}

			this.$confirm("确认补款吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.isSubmitting = true;
					PayVipRechargeMoney({
						keyId: this.currentArrearsOrder.keyId,
						payTypes: this.payTypes
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "充值记录补款成功！"
								});
								this.getListData();
								this.dialogVisible = false;
								this.payType = {
									keyId: "",
									payTypeId: 1,
									payMoney: 0,
									payComment: ""
								};
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("充值记录补款失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消充值记录补款"
					});
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		GetEnumConfigListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetPayTypeList(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						res.data.forEach((item) => {
							//充值不允许使用会员卡销支付（后端规则：充值流程不扣储值卡余额），下拉中过滤
							if (parseInt(item.code) === 5) {
								return;
							}
							this.payTypeList.push({
								payTypeId: parseInt(item.code),
								payTypeName: item.name
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取支付方式失败!");
				});

			const stateParamer = {
				code: "RechargeState"
			};
			GetEnumConfigDropListByCode(stateParamer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = res.data;
					}
				})
				.catch((err) => {
					this.stateList = [];
				});
		},
		// 验证赠送金额是否符合规则
		isBonusMoneyValid(rechargeMoney, bonusMoney) {
			// 根据充值金额计算应有的赠送金额
			let expectedBonus = 0;
			if (rechargeMoney >= 1000 && rechargeMoney < 2000) {
				expectedBonus = 100;
			} else if (rechargeMoney >= 2000 && rechargeMoney < 3000) {
				expectedBonus = 200;
			} else if (rechargeMoney >= 3000 && rechargeMoney < 5000) {
				expectedBonus = 500;
			} else if (rechargeMoney >= 5000) {
				expectedBonus = 1000;
			}
			// 返回实际赠送金额是否与预期相符
			return bonusMoney === expectedBonus;
		},
		// 显示充值记录详情弹窗
		handleShowDetail(row) {
			this.$refs.detailDialog.getDetailDialog(row);
		},
		// 门店改变时获取客户列表并搜索
		handleStoreChange(val) {
			this.GetCustomerListByStore(val);
			this.search();
		},
		// 会员卡退卡充值
		handleReturnCard(row) {
			this.$confirm("确认充值记录退款吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				ReturnVIPRecharge({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "充值记录退款成功！"
							});
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("充值记录退款失败，请稍后再试！");
					});
			});
		}
	}
};
</script>

<style scoped>
.red-text {
	color: red;
}

.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}

.danger {
	background: red;
	color: white;
	border-radius: 2px;
	width: 100%;
	height: 100%;
	display: inline-block;
}

.pay-types-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-type-row {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	background: #f9f9f9;
	border-radius: 4px;
}

.pay-type-name {
	width: 80px;
	font-weight: 500;
	color: #333;
}

.recharge-arrears-dialog {
	.el-dialog__body {
		padding-top: 15px;
		padding-bottom: 10px;
		max-height: 60vh;
		overflow-y: auto;
	}
}

.arrears-dialog-content {
	width: 100%;
}

.arrears-form {
	.el-form-item {
		margin-bottom: 15px;
	}
}

.pay-types-row {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
}

.pay-type-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #fafafa;
	border-radius: 6px;
	border: 1px solid #ebeef5;
	transition: all 0.3s ease;
	gap: 15px;
	width: calc(50% - 7.5px);
	box-sizing: border-box;

	&:hover {
		border-color: #409eff;
		background: #f0f9ff;
	}

	&-active {
		border-color: #409eff;
		background: #f0f9ff;
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.15);
	}
}

.pay-type-label {
	width: 60px;
	font-weight: 600;
	color: #303133;
	font-size: 14px;
	flex-shrink: 0;
}

.pay-types-row .el-input-number {
	width: 140px;
	flex-shrink: 0;
}

.pay-types-row .el-input {
	flex: 1;
	min-width: 100px;
}
</style>
